import interceptor from '@/plugins/interceptor';
const pathController = '/Security'

export default {
    state: () => ({
      redirectTo: null,
    }),
    getters: {
      getRedirectPath: state => state.redirectTo,
    },
    mutations: { 
      redirectAfterLogin(state,path){
        state.redirectTo = path;
      }
    },
    actions: {
      async security_authenticate(_, model) {
        return await interceptor.anonymous.post(`${process.env.VUE_APP_API_SECURITY_URL}${pathController}/authenticate`, model);
      },
      async security_SSO(_, model) {
        return await interceptor.anonymous.post(`${process.env.VUE_APP_API_SECURITY_URL}${pathController}/forgeSSO`, model);   
      },
      async security_beginPasswordRecovery(_, model) {
        return await interceptor.anonymous.post(`${process.env.VUE_APP_API_SECURITY_URL}${pathController}/beginPasswordRecovery`, model);
      },
      async security_endPasswordRecovery(_, model) {
        return await interceptor.anonymous.post(`${process.env.VUE_APP_API_SECURITY_URL}${pathController}/endPasswordRecovery`, model);
      },
      async security_resendRecoveryMail(_, model) {
        return await interceptor.anonymous.post(`${process.env.VUE_APP_API_SECURITY_URL}${pathController}/resendRecoveryMail`, model);
      },
      async security_refreshToken(_, model) {
        return await interceptor.anonymous.post(`${process.env.VUE_APP_API_SECURITY_URL}${pathController}/refreshToken`, model);   
      },
      async security_pickRole(_, model) {
        return await interceptor.authenticate.post(`${process.env.VUE_APP_API_SECURITY_URL}${pathController}/pickRoll`, model);   
      },
      async courses_newAuthenticate(_, model) {
        return await interceptor.authenticate.post(
          `${process.env.VUE_APP_API_SECURITY_URL}${pathController}/newAuthenticate`,
          model
        );
      },
      async courses_hasChangedPassword() {
        return await interceptor.authenticate.get(
          `${process.env.VUE_APP_API_SECURITY_URL}${pathController}/hasChangedPassword`
        );
      },
      async courses_changePassword(_, model) {
        return await interceptor.authenticate.put(
          `${process.env.VUE_APP_API_SECURITY_URL}${pathController}/password`,
          model
        );
      }
    }
  }